/**
 * Sistema centralizado de query keys para React Query
 * Garantiza consistencia y facilita la invalidación de caché
 */

export function createQueryKeys(domain: string) {
  return {
    all: [domain] as const,
    lists: () => [...createQueryKeys(domain).all, 'list'] as const,
    list: (filters?: Record<string, any>) => [...createQueryKeys(domain).lists(), { filters }] as const,
    paginated: (params?: { page?: number; limit?: number; filters?: Record<string, any> }) =>
      [...createQueryKeys(domain).all, 'paginated', params] as const,
    infinite: (filters?: Record<string, any>) => [...createQueryKeys(domain).all, 'infinite', { filters }] as const,
    details: () => [...createQueryKeys(domain).all, 'detail'] as const,
    detail: (id: string | number) => [...createQueryKeys(domain).details(), id] as const,
    products: (id: string | number) => [...createQueryKeys(domain).detail(id), 'products'] as const,
  };
}

// Query keys específicos para cada dominio
export const categoryKeys = createQueryKeys('categories');
export const collectionKeys = createQueryKeys('collections');
export const productKeys = createQueryKeys('products');
export const orderKeys = createQueryKeys('orders');
export const userKeys = createQueryKeys('users');
export const couponKeys = createQueryKeys('coupons');
export const dashboardKeys = createQueryKeys('dashboard');
export const favoriteKeys = createQueryKeys('favorites');
export const emailKeys = createQueryKeys('emails');